<template>
  <page>
    <v-card>
      <v-flex xs12>
        <form>
          <v-expansion-panel expand :value="[true]">
            <v-expansion-panel-content>
              <div slot="header">
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg4 xs6>
                        <v-text-field v-model="filters.scheme" :label="filtersLabel.scheme" :error-messages="errors.collect('scheme')" data-vv-name="scheme" :data-vv-as="filtersLabel.inter" v-validate="'param|max:4'"></v-text-field>
                      </v-flex>
                      <v-flex xl3 lg4 xs6>
                        <v-autocomplete :items="schemeTypeList" v-model="filters.schemeType" :label="filtersLabel.schemeType" item-text="label" item-value="value" data-vv-name="schemeType" :data-vv-as="filtersLabel.schemeType" :error-messages="errors.collect('schemeType')" clearable></v-autocomplete>
                      </v-flex>
                    </v-layout>
                    <transition name="slide-x-transition" mode="out-in">
                      <v-layout row wrap v-if="showDetailFilters">
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.minInsdAge" :label="filtersLabel.minInsdAge" :error-messages="errors.collect('minInsdAge')" data-vv-name="minInsdAge" :data-vv-as="filtersLabel.minInsdAge" v-validate="'numeric|max:10'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.maxInsdAge" :label="filtersLabel.maxInsdAge" :error-messages="errors.collect('maxInsdAge')" data-vv-name="maxInsdAge" :data-vv-as="filtersLabel.maxInsdAge" v-validate="'numeric|max:10'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.maxInsdRenAge" :label="filtersLabel.maxInsdRenAge" :error-messages="errors.collect('maxInsdRenAge')" data-vv-name="maxInsdRenAge" :data-vv-as="filtersLabel.maxInsdRenAge" v-validate="'numeric|max:10'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.maxChildAge" :label="filtersLabel.maxChildAge" :error-messages="errors.collect('maxChildAge')" data-vv-name="maxChildAge" :data-vv-as="filtersLabel.maxChildAge" v-validate="'numeric|max:10'"></v-text-field>
                        </v-flex>
                        <v-flex xl3 lg4 xs6>
                          <v-text-field v-model="filters.maxStudentAge" :label="filtersLabel.maxStudentAge" :error-messages="errors.collect('maxStudentAge')" data-vv-name="maxStudentAge" :data-vv-as="filtersLabel.inter" v-validate="'numeric|max:10'"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </transition>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-btn flat="flat" @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" flat="flat" @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" flat="flat" type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </form>
      </v-flex>
      <v-flex xs12 class="mt-3">
        <message :messages="messages"></message>
      </v-flex>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-card-title>
              <v-spacer></v-spacer>
              <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
                <v-btn color="secondary" class="white--text" slot="activator">
                  <span>Columns</span>
                  <v-icon right dark>mdi-table-column-plus-after</v-icon>
                </v-btn>
                <v-card>
                  <v-card-text>
                    <template v-if="columns.length > 0">
                      <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                    </template>
                    <template v-else>
                      No column found
                    </template>
                  </v-card-text>
                </v-card>
              </v-menu>
            </v-card-title>
            <v-data-table v-bind:headers="listHeaders" v-bind:items="items" :rows-per-page-items="itemsPerPage" :totalItems="totalItems" v-bind:pagination.sync="pagination" item-key="index" :loading="loading" :no-data-text="noDataText">
              <template slot="items" slot-scope="props">
                <td v-for="column in selectedColumns" :key="column">
                  {{props.item[column]}}
                </td>
                <td class="text-xs-right">
                  <table-action :rowData="props" review @review="doReview" remove @remove="doPromptRemove(props.item)"></table-action>
                </td>
              </template>
            </v-data-table>
            <v-btn color="primary" dark class="mb-2" @click="doNewScheme">New Scheme<v-icon>mdi-plus</v-icon></v-btn>
            <confirm v-model="promptRemove" @ok="doRemove">
              Are you sure that you want to delete the selected Scheme?
              <div class="title">{{deleteScheme}}</div>
            </confirm>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </page>
</template>

<script>
import { mapGetters } from 'vuex'
import { filterQuery, expandURI } from '@/utils/ajax'
import MessageMixin from '@/mixins/message'
import { listMixin } from '@/components/parameters/reusable/listMixins'
import { schemeType } from '@/const/params'

export default {
  data() {
    return {
      filtersLabel: {
        scheme: 'Scheme',
        schemeDesc: 'Scheme Description',
        schemeType: 'Scheme Type',
        minInsdAge: 'Minimum Insured Age',
        maxInsdAge: 'Maximum Insured Age',
        maxInsdRenAge: 'Maximum Insured Renewal Age',
        maxChildAge: 'Maximum Child Age',
        maxStudentAge: 'Maximum Student Age'
      },
      columns: [
        { text: 'Scheme', value: 'schemeDesc' },
        { text: 'Scheme Type', value: 'schemeTypeDesc' },
        { text: 'Minimum Insured Age', value: 'minInsdAge' },
        { text: 'Maximum Insured Age', value: 'maxInsdAge' },
        { text: 'Maximum Insured Renewal Age', value: 'maxInsdRenAge' },
        { text: 'Maximum Child Age', value: 'maxChildAge' },
        { text: 'Maximum Student Age', value: 'maxStudentAge' }
      ],
      selectedColumns: ['schemeDesc', 'schemeTypeDesc'],
      filters: {
        scheme: null,
        schemeDesc: null,
        schemeType: null,
        minInsdAge: null,
        maxInsdAge: null,
        maxInsdRenAge: null,
        maxChildAge: null,
        maxStudentAge: null
      },
      schemeForm: {
        scheme: null,
        schemeType: null,
        minInsdAge: null,
        maxInsdAge: null,
        maxInsdRenAge: null,
        maxChildAge: null,
        maxStudentAge: null
      },
      loading: null,
      showDetailFilters: false,
      schemeTypeList: [],
      deleteScheme: '',
      promptRemove: false
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    schemeMenu() {
      return this.$store.state.parameters.scheme.menu
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination.descending': function (value) {
      this.fetchData(false)
    },
    'pagination.page': function (value) {
      this.fetchData(false)
    },
    'pagination.rowsPerPage': function (value) {
      this.fetchData(false)
    },
    'pagination.sortBy': function (value) {
      this.fetchData(false)
    }
  },
  methods: {
    async fetchData(options) {
      const apiURI = this.schemeMenu.schemes
      const { page, rowsPerPage } = this.pagination
      let expand = {
        page: page - 1,
        size: rowsPerPage
      }
      if (apiURI) {
        const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), this.filters, this.pagination.sortBy, this.pagination.descending))
        if (result.data) {
          this.totalItems = result.data.totalElements
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((scheme) => {
              const convertScheme = {
                scheme: scheme.scheme,
                schemeDesc: scheme.scheme + ' - ' + scheme.schemeDesc,
                schemeType: scheme.schemeType,
                schemeTypeDesc: scheme.schemeType + ' - ' + scheme.schemeTypeDesc,
                minInsdAge: scheme.minInsdAge,
                maxInsdAge: scheme.maxInsdAge,
                maxInsdRenAge: scheme.maxInsdRenAge,
                maxChildAge: scheme.maxChildAge,
                maxStudentAge: scheme.maxStudentAge
              }
              this.items.push(convertScheme)
            })
            this.loading = false
          } else {
            this.items = []
          }
        }
      }
    },
    doClearFilters() {
      this.filters.scheme = null
      this.filters.schemeDesc = null
      this.filters.schemeType = null
      this.filters.schemeTypeDesc = null
      this.filters.minInsdAge = null
      this.filters.maxInsdAge = null
      this.filters.maxInsdRenAge = null
      this.filters.maxChildAge = null
      this.filters.maxStudentAge = null
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
          this.resetValidator()
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doReview(data) {
      this.$router.push({ name: 'schemeReview', params: { scheme: data.item.scheme } })
    },
    doNewScheme() {
      this.$router.push({ name: 'schemeReview', params: { scheme: 'new' } })
    },
    schemeTypeListInit() {
      const list = Object.freeze(schemeType)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      this.schemeTypeList = convertArray
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedScheme = data
        this.deleteScheme = data.schemeDesc
      }
    },
    async doRemove() {
      const apiURI = this.schemeMenu.schemeDelete
      if (apiURI) {
        this.loading = true
        const expand = {
          scheme: this.selectedScheme.scheme,
          schemeDesc: this.selectedScheme.schemeDesc,
          schemeType: this.selectedScheme.schemeType,
          schemeTypeDesc: this.selectedScheme.schemeTypeDesc,
          minInsdAge: this.selectedScheme.minInsdAge,
          maxInsdAge: this.selectedScheme.maxInsdAge,
          maxInsdRenAge: this.selectedScheme.maxInsdRenAge,
          maxChildAge: this.selectedScheme.maxChildAge,
          maxStudentAge: this.selectedScheme.maxStudentAge
        }
        try {
          const result = await this.$http.post(apiURI, expand)
          this.notify(result.data)
          // Reinit
          this.fetchData(true)
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Scheme')
      }
    }
  },
  created() {
    Promise.all([this.fetchData(true), this.schemeTypeListInit()])
  },
  mixins: [
    MessageMixin,
    listMixin
  ]
}
</script>

<style>

</style>
